import { Injectable } from '@angular/core';

import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class SwalService {

  constructor() {}

  fireSuccessSwal(message: string) {
    return Swal.fire({
      type: 'success',
      text: message || 'Operação realizada com sucesso'
    });
  }

  fireErrorSwal(message: string) {
    return Swal.fire({
      type: 'error',
      title: 'Erro',
      text: message || 'Ocorreu um erro na operação',
      confirmButtonText: 'OK'
    });
  }

  fireConfirmSwal() {
    try {
      const result = Swal.fire({
        type: 'warning',
        title: 'Confirmação',
        text: "Tem certeza dessa ação?",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      });
      return result;
    } catch (error) {
      throw error;
    }
  }
}
